import React, { useContext } from 'react'
import { AppContext } from '@state/context'
import { closePanel } from '@state/actions/panelsActions'
import Button from '@components/Button'
import {
  PANELS,
  BUTTON_SIZE,
} from '@helpers/constants'
import RegisterStudentLink from '@components/RegisterStudentLink'

const RegisterStudentsPanel = () => {
  const [state, dispatch] = useContext(AppContext)
  const { school, schoolClass } = state?.panels?.panelData ?? {}

  return (
    <>
      <div className={'relative'}>
        <div className='absolute top-0 right-0'>
          <Button
            handleClick={() => {
              dispatch(closePanel(PANELS.REGISTER_STUDENTS))
            }}
            size={BUTTON_SIZE.NO_PADDING}
            icon={'Close'}
          ></Button>
        </div>
      </div>

      <div className={'flex flex-col items-center'}>
        <RegisterStudentLink
          school={school}
          schoolClass={schoolClass}
        />
      </div>
    </>
  )
}

export default RegisterStudentsPanel
